module.exports = __webpack_public_path__ + "static/media/logo.587b3b91.png";